// Utilitários de controle de turno
// Turnos fixos de 12h: Dia 07:00–19:00 / Noite 19:00–07:00

// Converte "HH:MM" para minutos desde meia-noite
const hhmm = (str) => {
  const [h, m] = str.split(":").map(Number);
  return h * 60 + m;
};

/**
 * Verifica se o horário atual está dentro da janela permitida:
 * [turno_inicio - 20 min, turno_fim)
 * Retorna true se não houver restrição (turno_inicio ou turno_fim null).
 */
export function dentroDoTurno(turno_inicio, turno_fim) {
  if (!turno_inicio || !turno_fim) return true;

  const nowM  = new Date().getHours() * 60 + new Date().getMinutes();
  const iniM  = hhmm(turno_inicio);
  const fimM  = hhmm(turno_fim);
  const janM  = iniM - 20; // 20 minutos antes do início

  if (iniM < fimM) {
    // Turno no mesmo dia (ex: 07:00–19:00)
    return nowM >= janM && nowM < fimM;
  } else {
    // Turno que cruza meia-noite (ex: 19:00–07:00)
    return nowM >= janM || nowM < fimM;
  }
}

/**
 * Mensagem exibida quando o login é bloqueado por horário.
 */
export function msgTurnoFechado(turno_inicio) {
  if (!turno_inicio) return "Fora do horário de plantão.";
  const totalMin = hhmm(turno_inicio) - 20;
  const jH = String(Math.floor(totalMin / 60)).padStart(2, "0");
  const jM = String(totalMin % 60).padStart(2, "0");
  return `Seu plantão começa às ${turno_inicio}. Você poderá acessar a partir das ${jH}:${jM}.`;
}

/**
 * Verifica se a sessão expirou: agora > turno_fim + 30 min.
 * loginTimestamp: ISO string do momento do login.
 */
export function sessaoExpirada(loginTimestamp, turno_inicio, turno_fim) {
  if (!loginTimestamp || !turno_inicio || !turno_fim) return false;

  const [hI, mI] = turno_inicio.split(":").map(Number);
  const [hF, mF] = turno_fim.split(":").map(Number);
  const iniM = hI * 60 + mI;
  const fimM = hF * 60 + mF;

  const loginDate  = new Date(loginTimestamp);
  const loginDayM  = loginDate.getHours() * 60 + loginDate.getMinutes();

  // Data/hora de fim esperada
  const fimDate = new Date(loginDate);
  fimDate.setHours(hF, mF, 0, 0);

  if (iniM >= fimM) {
    // Turno noturno: 19:00–07:00
    if (loginDayM >= iniM - 20) {
      // Login durante a noite → fim é no dia seguinte
      fimDate.setDate(fimDate.getDate() + 1);
    }
    // Login após meia-noite → fim é hoje (já setado acima)
  }
  // Turno diurno: fimDate está no mesmo dia que o login

  return new Date() > new Date(fimDate.getTime() + 30 * 60 * 1000);
}

// Chave de localStorage para o timestamp de login do vigilante
export const loginTsKey = (vigilanteId) => `vigia_login_ts_${vigilanteId}`;
